module.exports = __webpack_public_path__ + "img/svg/background-no-money.470ca755a7020b36777487bf01b9aaee.svg";